import {jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'
import {Link} from 'react-router-dom'

import {ActivityCard, ActivityCardImage} from './ActivityCard'
import ActivityCardFavorite from './ActivityCardFavorite'

import {ActivityLibraryCardDescription} from './ActivityLibraryCardDescription'
import {CATEGORY_THEMES,} from './Categories'







const ActivityGrid = (props) => {
  const {templates, selectedCategory, viewerRef} = props
  const viewer = useFragment(
    graphql`
      fragment ActivityGrid_user on User {
        ...ActivityCardFavorite_user
      }
    `,
    _nullishCoalesce(viewerRef, () => ( null))
  )
  return (
    _jsx(_Fragment, { children: 
      templates.map((template) => {
        return (
          _jsx(Link, {

            to: {
              pathname: `/activity-library/details/${template.id}`,
              state: {prevCategory: selectedCategory}
            },
            className: "flex rounded-2xl hover:bg-slate-100 focus:outline-sky-500"   ,
 children: 
            _jsxs(ActivityCard, {
              className: "group aspect-256/160 flex-1"  ,

              theme: CATEGORY_THEMES[template.category ],
              title: template.name,
              type: template.type,
              templateRef: template,
 children: [
              _jsx(ActivityCardImage, {
                className: "group-hover/card:hidden",
                src: template.illustrationUrl,
                category: template.category ,}
              )
              , viewer && (
                _jsx(ActivityCardFavorite, {
                  templateId: template.id,
                  className: "absolute right-2 bottom-2"  ,
                  viewerRef: viewer,}
                )
              )
              , _jsx(ActivityLibraryCardDescription, {
                className: "hidden group-hover/card:flex" ,
                templateRef: template,}
              )
            ]}, template.id)
          }, template.id)
        )
      })
    })
  )
}

export default ActivityGrid
